/**
 * Navigation contributed by the ADMIN layer.
 *
 * This file is the layer's ENTIRE contribution to the sidebar. It does not
 * import, wrap or copy AppShell — the shell discovers this file by glob and
 * merges it. See nav.base.ts for why.
 *
 * `role` hides these from non-admins, which is presentation only. The gates
 * that matter are AdminLayoutRoute's role check on /admin and the API's own
 * check on every /admin endpoint.
 */
import { Settings } from 'lucide-react';
import type { NavItem } from './nav.base';

/*
 * ONE entry, not four, under its own "Firm" heading.
 *
 * Analytics, users and the audit log are all administration of the same
 * thing, visited rarely, and they were taking four of the sidebar's most
 * valuable rows from the practice work people are actually here to do. They
 * now live as tabs inside the admin area — see AdminPageHeader, which renders
 * the sub-nav for every page under /admin.
 *
 * The heading separates it from "Set up" above: those configure the intake
 * product; this configures the firm's account — who can sign in, what the
 * emails are signed, what happened. Different question, different group.
 */
export const items: NavItem[] = [
  /* No section of its own: it sorts into the intake layer's "Tools" group,
   * which is where a firm looks for it rather than under a heading of one. */
  { to: '/admin', label: 'Settings', icon: Settings, end: false, role: 'admin', order: 80 },
];
